/* eslint-disable react-hooks/exhaustive-deps */
import React from "react";

import { useHistory } from "react-router-dom";

import { useAuthGlobal } from "../../../../../contexts/auth-context/auth-context";

import { CNAESModel } from "../../../../../domain/models/cnae";
import { DeveloperCompanyModel } from "../../../../../domain/models/developer-company.model";

import IssueForm from "../../../../../presentation/pages/developer/issue/form";

import toastUtils from "../../../../../utils/ToastUtils";
import { getErrorMessage } from "../../../../../presentation/helpers";

import { makeRemoteCNAES } from "../../../usecases/cnaes/remote-cnaes-factory";
import { makeRemoteDeveloperCompanies } from "../../../usecases/developer-companies/remote-developer-companies-factory";
import { makeRemoteFiscalNote } from "../../../usecases/fiscal-note/remote-fiscal-note-factory";

const MakeIssue: React.FC = () => {
  const [developerCompaniesList, setDeveloperCompaniesList] = React.useState<
    DeveloperCompanyModel[]
  >([]);

  const [cnaesList, setCnaesList] = React.useState<CNAESModel[]>([]);

  const [submitting, setSubmitting] = React.useState<boolean>(false);

  const { user } = useAuthGlobal();

  const history = useHistory();

  React.useEffect(() => {
    (async () => {
      const econ = await makeRemoteDeveloperCompanies().getByDeveloper();
      
      setDeveloperCompaniesList(econ);
    })();
  }, []);

  React.useEffect(() => {
    (async () => {
      const econ = await makeRemoteCNAES().loadAll({
        query: user?.developerResponseDTO?.address?.city?.id,
      });
      setCnaesList(econ);
    })();
  }, []);

  const handleSubmit = async (
    values: any,
    setShowConfirm: any,
  ): Promise<void> => {
    setSubmitting(true);
    console.log("VALUES: ", values);
    try {
      if (!values?.taker?.id) {
        toastUtils.showMessage({
          type: "warning",
          message: "Por favor, selecione um tomador!",
        });
        setSubmitting(false);
        return;
      }

      await makeRemoteFiscalNote().create({
        cnae: values?.cnae?.code,
        ctiss: values?.cnae?.description,
        developerCompany: {
          id: values?.company,
        },
        observation: values?.description,
        serviceList: [
          {
            conditionedDiscount: Number(
              values?.conditionedDiscount
                ?.replaceAll(".", "")
                .replaceAll(",", "."),
            ),
            economicActivity: {
              id: values?.activityEconomy,
            },
            issAliquot: Number(
              values.simplesNacional
                ? 0
                : values?.issAliquot?.replaceAll(".", "").replaceAll(",", "."),
            ),
            issRetained: values?.iss === "true",
            otherDeductions: Number(
              values?.otherDeductions?.replaceAll(".", "").replaceAll(",", "."),
            ),
            serviceValue: Number(
              values?.serviceValue?.replaceAll(".", "").replaceAll(",", "."),
            ),
            unconditionalDiscount: Number(
              values?.unconditionalDiscount
                ?.replaceAll(".", "")
                .replaceAll(",", "."),
            ),
          },
        ],
        taker: {
          id: values?.taker?.id,
        },
        competencia: values?.competencia,
        emissionDate: values?.emissionDate,
        hasRecurrence: values?.hasRecurrence === "true",
      });
      setShowConfirm(true);
      setTimeout(() => {
        setShowConfirm(false);
        history.push("/documents");
      }, 6000);
      toastUtils.showMessage({
        type: "success",
        message: "Gerando com Sucesso!",
      });
    } catch (error: any) {
      const errorMessage = getErrorMessage(error);
      toastUtils.showMessage({
        type: "error",
        message: errorMessage,
      });
    }
    setSubmitting(false);
  };
  return (
    <IssueForm
      loading={false}
      handleSubmit={handleSubmit}
      cnaesList={cnaesList}
      developerCompaniesList={developerCompaniesList}
      setCnaesList={setCnaesList}
      submitting={submitting}
    />
  );
};

export default MakeIssue;
